import React from 'react';
import {EmptyCardFileProps} from "../../types/types";
import classes from "./EmptyCardFile.module.css";
import Button from "../Button/Button";
import { triggerEvent } from '../../utils/eventRegistry';

const EmptyCardFile: React.FC<EmptyCardFileProps> = (props) => {

    const handleButtonClick = () => {
        triggerEvent('OnAddCard');
    };

    const buttonStyle = {
        height: '40px',
        width: '60px'
    };

    return (
        <div className={classes.container}>
            <div className={classes.imageContainer}>
                <img className={classes.image} src={props.imageSrc} alt="Пустой список"></img>
            </div>
            <div className={classes.textBlock}>
                <span className={classes.header}>
                    {props.header}
                </span>
                <span className={classes.description}>
                    {props.description}
                </span>
            </div>
            <Button className={classes.button} style={buttonStyle} onClick={handleButtonClick}>
                +
            </Button>
        </div>
    );
};

export default EmptyCardFile;